import client from "libs/HttpClient";

/**
 * Service class for handling Licence Update.
 */
class LicenceUpdateService {
  /**
   * Retrieves the details of a Order Item based on the provided parameters.
   *
   * @param params - The parameters for retrieving the Order Item details.
   * @returns A Promise that resolves to the Axios response containing the Order Item details.
   */
  static getOrderItemDetails(params: any) {
    return client.get("admin/update-licence/get-order-item-details", {
      params,
    });
  }

  /**
   * update Licence based on the provided request.
   *
   * @param request - The request parameters for adding a Cart.
   * @returns A Promise that resolves to the Axios response for the add Cart request.
   */
  static updateLicenceData(request: any) {
    return client.put("admin/update-licence/update-licence-data", request);
  }
}

export { LicenceUpdateService };
